import { useQuery } from "@tanstack/react-query";
import $api from "~@/api";
import { GetTournamentsByCityInput } from "~@/api/models";

const fetchTournamentsByCity = async (variables: GetTournamentsByCityInput) => {
  const { data } = await $api.tournaments.getTournamentsByCity({
    ...variables,
  });

  return data;
};

const useTournamentsByCityQuery = (cityId: number | undefined) => {
  const { data, isLoading, isPending, isError } = useQuery({
    queryKey: ["tournament-by-city", cityId],
    queryFn: () => {
      return fetchTournamentsByCity({
        cityId: cityId!,
      });
    },
    enabled: typeof cityId === "number",
  });

  return { data, isLoading, isPending, isError };
};

export default useTournamentsByCityQuery;
